/* globals jQuery */
/* exported pxlCookie */

if (window.NodeList && !NodeList.prototype.forEach) {NodeList.prototype.forEach = Array.prototype.forEach;}

var pxlCookie = {
  create(name, value, days = false) {
    var date = new Date(), expires = '';
    
    if ( days ) {
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    }
    else expires = "; expires=Tue, 19 Jan 2088 03:14:07 UTC";
    
    document.cookie = name+"="+value+expires+"; path=/";
    
    return true;
  },
  erase(name) {
    this.create(name,"",-1);
  },
  read(name) {
    var nameEQ = name + "=", ca = document.cookie.split(';');
    
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    
    return false;
  }
};

(function($){
  // Adds a class to navbar when user is no longer at the top of the page for targeting style changes for fixed navbars
    var c, currentScrollTop = 0;
    function nav() {
      var $navbar = $('#navbar'),
          pos     = (document.documentElement.scrollTop||document.body.scrollTop);
          
      currentScrollTop = pos;
      if (!$navbar.hasClass('static')){
        if (c < currentScrollTop && pos > 100) $navbar.addClass("scrollUp");
        else if (c > currentScrollTop && !(pos <= 100)) $navbar.removeClass("scrollUp");
        
        if (pos > 10) $navbar.addClass("scrolled");
        else $navbar.removeClass("scrolled");
        
        c = currentScrollTop;
      }
      
      return false;
    }
    
  // Menu Tray
    function menutray() {
      var body = document.querySelector('body'), menu = document.getElementById('menutray');
      
      if ( menu ) {
        var openBtns  = document.querySelectorAll('.more'),
            closeBtn  = menu.querySelector('.closebtn'),
            activeBtn = false;
            
        menu.style.display = '';
            
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          menu.classList.remove('open');
          removeClickListener();
          return false;
        });
        
        const outsideClickListener = function( event ) {
          if ( !menu.contains(event.target) && !activeBtn.contains(event.target) ) {
            event.preventDefault();
            removeClickListener();
          }
        },
        removeClickListener = function() {
          body.classList.remove('scroll-lock');
          menu.classList.remove('open');
          document.removeEventListener('click', outsideClickListener, {capture:true})
        }
        
        openBtns.forEach(function( btn ) {
          btn.addEventListener('click', function( event ) {
            event.preventDefault();
            activeBtn = btn;
            
            if ( event.target == btn && menu.classList.contains('open') ) {
              menu.classList.remove('open');
              removeClickListener();
            }
            else {
              body.classList.add('scroll-lock');
              menu.classList.add('open');
              document.addEventListener('click', outsideClickListener, {capture:true});
            }
            
            return false;
          });
        });
      }
    }
    
  // Visibility observer for animation triggering
    function observerInit(){
      var targets = [].slice.call(document.querySelectorAll('.content > *')),
          config = {
            rootMargin: '0px',
            threshold: 0.1
          };
          
      if ( !('IntersectionObserver' in window) ) {
        targets.forEach(function(target) {
          if ( target.tagName !== 'FIGURE' ) target.classList.add('visible');
        });
      } else {
        let observer = new IntersectionObserver(onIntersection, config);
        targets.forEach(target => {
          observer.observe(target);
        });
      }
    }
    function onIntersection(entries) {
      entries.forEach(entry => {
        if ( entry.target.tagName !== 'FIGURE' ) {
          if ( entry.isIntersecting ) entry.target.classList.add('visible');
          else entry.target.classList.remove('visible');
        }
      });
    }
    
  // Cover Video Autoplay for Tablets and Mobile
    function coverVideo() {
      var video = document.querySelector('video[autoplay]');
      if ( video ) {
        video.setAttribute('playsinline', true);
        if ( video.paused ) video.play();
      }
    }
    
  function inputCheck( field, tag ) {
    var filled = tag === 'SELECT' ? field.selectedOptions[0].value.length > 0 : field.value.length > 0;
  
    if ( filled ) field.closest('.gfield').classList.add('move-label');
    else field.closest('.gfield').classList.remove('move-label');
  }
  function inputLabel() {
    var gfInputs = Object.values(document.querySelectorAll('.ginput_container input'));
  
    gfInputs.forEach(function(field) {
      var tag = field.tagName;
    
      inputCheck(field, tag);
    
      field.addEventListener('keyup', function(event) {
        inputCheck(event.target, tag);
      });
    
      field.addEventListener('change', function(event) {
        inputCheck(event.target, tag);
      });
    });
  }
    
  $(function(){
    coverVideo();
    menutray();
    nav();
    observerInit();
    
    inputLabel();
    
    $(window).scroll(function() { nav(); });
  })
})(jQuery);
